document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-primary-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });
  }

  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => track?.scrollBy({ left: -340, behavior: 'smooth' }));
    carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => track?.scrollBy({ left: 340, behavior: 'smooth' }));
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const formWrap = root.querySelector('[data-product-form]');
    if (!formWrap) return;

    const variantInput = formWrap.querySelector('[name="id"]');
    const mainImage = root.querySelector('[data-product-main-image]');
    const price = root.querySelector('[data-product-price]');
    const button = formWrap.querySelector('button[type="submit"]');
    const thumbnails = Array.from(root.querySelectorAll('[data-product-thumbnail]'));

    const setActiveThumbnail = (mediaId) => {
      if (!mediaId) return;
      thumbnails.forEach((thumb) => {
        const active = thumb.dataset.mediaId === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    };

    const setMainImage = (src, alt, mediaId) => {
      if (!mainImage || !src) return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = src;
      if (alt) mainImage.alt = alt;
      if (mediaId) mainImage.dataset.mediaId = String(mediaId);
      setActiveThumbnail(mediaId);
    };

    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        setMainImage(thumb.dataset.imageSrc, thumb.dataset.imageAlt, thumb.dataset.mediaId);
      });
    });

    if (!variantInput) return;

    const updateFromVariant = () => {
      const option = variantInput.tagName === 'SELECT'
        ? variantInput.options[variantInput.selectedIndex]
        : variantInput;
      if (!option) return;

      const mediaId = option.dataset.mediaId;
      const imageSrc = option.dataset.imageSrc;
      const imageAlt = option.dataset.imageAlt;
      const available = option.dataset.available !== 'false';

      if (imageSrc) setMainImage(imageSrc, imageAlt, mediaId);
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        button.disabled = !available;
        button.textContent = available ? 'Add to cart →' : 'Sold out';
      }
    };

    variantInput.addEventListener('change', updateFromVariant);
  });
});
